module.exports = __webpack_public_path__ + "static/media/lock_open.3d308da5.svg";